export default "__VITE_ASSET__0089ccd7__"